module.exports = __webpack_public_path__ + "static/media/paper.b710b004.png";